import { BaseSopOperation } from "./_Base";
import { SphereBufferGeometry } from "three";
import { IcosahedronBufferGeometry } from "three";
import { Vector2 } from "three";
import { Vector3 } from "three";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { isBooleanTrue } from "../../../core/BooleanValue";
var SphereType = /* @__PURE__ */ ((SphereType2) => {
  SphereType2["DEFAULT"] = "default";
  SphereType2["ISOCAHEDRON"] = "isocahedron";
  return SphereType2;
})(SphereType || {});
export const SPHERE_TYPE = {
  default: 0,
  isocahedron: 1
};
export const SPHERE_TYPES = ["default" /* DEFAULT */, "isocahedron" /* ISOCAHEDRON */];
export class SphereSopOperation extends BaseSopOperation {
  static type() {
    return "sphere";
  }
  cook(input_contents, params) {
    const core_group = input_contents[0];
    if (core_group) {
      return this._cookWithInput(core_group, params);
    } else {
      return this._cookWithoutInput(params);
    }
  }
  _cookWithoutInput(params) {
    const geometry = this._createRequiredGeometry(params);
    geometry.translate(params.center.x, params.center.y, params.center.z);
    return this.createCoreGroupFromGeometry(geometry);
  }
  _cookWithInput(core_group, params) {
    const bbox = core_group.boundingBox();
    const size = bbox.max.clone().sub(bbox.min);
    const center = bbox.max.clone().add(bbox.min).multiplyScalar(0.5);
    const geometry = this._createRequiredGeometry(params);
    geometry.scale(size.x, size.y, size.z);
    geometry.translate(params.center.x, params.center.y, params.center.z);
    geometry.translate(center.x, center.y, center.z);
    return this.createCoreGroupFromGeometry(geometry);
  }
  _createRequiredGeometry(params) {
    if (params.type == SPHERE_TYPE.default) {
      return this._createDefaultSphere(params);
    } else {
      return this._createDefaultIsocahedron(params);
    }
  }
  _createDefaultSphere(params) {
    if (isBooleanTrue(params.open)) {
      return new SphereBufferGeometry(params.radius, params.resolution.x, params.resolution.y, params.phiStart, params.phiLength, params.thetaStart, params.thetaLength);
    } else {
      return new SphereBufferGeometry(params.radius, params.resolution.x, params.resolution.y);
    }
  }
  _createDefaultIsocahedron(params) {
    return new IcosahedronBufferGeometry(params.radius, params.detail);
  }
}
SphereSopOperation.DEFAULT_PARAMS = {
  type: SPHERE_TYPE.default,
  radius: 1,
  resolution: new Vector2(30, 30),
  open: false,
  phiStart: 0,
  phiLength: Math.PI * 2,
  thetaStart: 0,
  thetaLength: Math.PI,
  detail: 1,
  center: new Vector3(0, 0, 0)
};
SphereSopOperation.INPUT_CLONED_STATE = InputCloneMode.FROM_NODE;
